"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenCategoryCrud = void 0;
const React = __importStar(require("react"));
const react_query_1 = require("react-query");
const styled_components_1 = __importDefault(require("styled-components"));
const koden_koden_icon_text_button_1 = require("@scott/koden.koden-icon-text-button");
const koden_koden_add_dialog_1 = require("@scott/koden.koden-add-dialog");
const koden_koden_panel_list_1 = require("@scott/koden.koden-panel-list");
const koden_koden_crud_1 = require("@scott/koden.koden-crud");
const Container = styled_components_1.default.div `
	> *:nth-of-type(2) {
		margin-top: 16px;
	}
`;
function KodenCategoryCrud({ resource, title, addColumns, listBackgroundColor, listColumns, columnPlaceHolder, }) {
    const queryClient = (0, react_query_1.useQueryClient)();
    const [open, setOpen] = React.useState(false);
    return (React.createElement(Container, null,
        React.createElement("div", null,
            React.createElement(koden_koden_icon_text_button_1.KodenIconTextButton, { text: "\u65B0\u589E", onClick: () => setOpen(true) })),
        React.createElement(koden_koden_add_dialog_1.KodenAddDialog, { title: `新增${title}`, resource: resource, open: open, columns: addColumns, onClose: () => {
                setOpen(false);
            }, onAddSuccess: (data) => __awaiter(this, void 0, void 0, function* () {
                yield (0, koden_koden_crud_1.refreshList)(queryClient, resource, data);
            }) }),
        React.createElement(koden_koden_panel_list_1.KodenPanelList, { title: title, headerBackgroundColor: listBackgroundColor, resource: resource, columns: listColumns, columnPlaceHolder: columnPlaceHolder })));
}
exports.KodenCategoryCrud = KodenCategoryCrud;
//# sourceMappingURL=koden-category-crud.js.map